import {
  object,
  string
} from "yup";

import "./schemas";

const hwrcSiteSchema = object({
  latitude: string()
    .trim()
    .validLatitude()
    .label("Latitude"),
  longitude: string()
    .trim()
    .validLongitude()
    .label("Longitude")
});

export default hwrcSiteSchema;
